export const css = {
    root: '_30XcqPLc',
    ' _key': 'afcpe-theme/afcpe/variants/mme1'
};
export default css;
